"use client";

import React, { useRef } from "react";
import BannerImageText from "@/components/JoinUs/BannerImageText/BannerImageText";
import InnovationFuture from "@/components/JoinUs/Innovation/InnovationFuture";
import PassionateCards from "@/components/JoinUs/PassionateCards/PassionateCards";
import { Footer } from "@/components/layout/Footer/Footer";
import Hero from "@/components/JoinUs/Hero/Hero";
import HorizontalPhotos from "@/components/JoinUs/HorizontalPhotos/HorizontalPhotos";
import JoinUsDuck from "@/components/JoinUs/Hero/JoinUsDuck";
import { useDeviceDetector } from "@/utils/useDeviceDetector";

const SectionJoinUs = ({ messages }: any) => {
  const { isMobile } = useDeviceDetector();
  const endTriggerRef = useRef<any>(null);

  return (
    <section className="work-with-us-wrapper" style={{ overflowX: "hidden" }}>
      {!isMobile && <JoinUsDuck endTrigger={endTriggerRef} />}
      <Hero messages={messages.hero} />
      <BannerImageText
        messages={messages.chooseUs}
        imagesCarrusel={messages.carruselImages}
        ref={endTriggerRef}
      />
      <InnovationFuture messages={messages.innovate} />
      <HorizontalPhotos
        messages={messages.horizontal}
        horizontalImages={messages.horizontalImages}
      />
      <PassionateCards messages={messages.postulation} />
      <Footer />
    </section>
  );
};

export default SectionJoinUs;

SectionJoinUs.displayName = "SectionJoinUs";
